import * as Sentry from '@sentry/react';

import { scrubEvent } from './scrub';

const sentryTestEnvironments = new Set(['preview', 'staging']);
const sentryTestQueryParam = 'sentry-test';

export const sentryEnvironment: string =
  import.meta.env.VITE_ENV || import.meta.env.MODE;

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  const release = import.meta.env.VITE_RELEASE_NAME;

  Sentry.init({
    dsn,
    enabled: !!dsn,
    environment: sentryEnvironment,
    ...(release && { release }),
    sendDefaultPii: false,
    beforeSend: scrubEvent,
  });
}

// Controlled test error, e.g. https://<preview-host>/?sentry-test=1
export function isSentryTestEnabled(): boolean {
  return (
    sentryTestEnvironments.has(sentryEnvironment) &&
    new URLSearchParams(globalThis.location.search).has(sentryTestQueryParam)
  );
}
